<template>
  <div class="jl-auc-view-wrap">
    <div class="jl-auc-view-banner">
      <div class="jl-container">
        <div class="jl-auc-banbox">
          <div class="jl-auc-bantop">
            <h2>
              {{ nowObj.title }}
              <div class="jl-auc-ban-tips">
                <div class="tips-text">
                  {{
                    nowObj.transactionType === 1
                      ? '进行中'
                      : nowObj.transactionType === 2
                      ? '已结束'
                      : '未开始'
                  }}
                </div>
              </div>
            </h2>
            <p>{{ nowObj.remarks }}</p>
          </div>
          <div class="jl-auc-bancontent">
            <div class="item-box">
              <div class="item-box-l">
                <div class="jl-table">
                  <div class="jl-table-cell">
                    <span class="span-1">{{
                      nowObj.transactionType === 1
                        ? '距离结束'
                        : nowObj.transactionType === 2
                        ? '截止时间'
                        : '距离开始'
                    }}</span>
                    <div
                      style="display: inline-block;vertical-align: middle;"
                      v-if="nowObj.transactionType !== 2"
                    >
                      <span class="span-2">{{ hh }}</span>
                      <span class="span-3">时</span>
                      <span class="span-2">{{ mm }}</span>
                      <span class="span-3">分</span>
                      <span class="span-2">{{ ss }}</span>
                      <span class="span-3">秒</span>
                    </div>
                    <div
                      style="display: inline-block;vertical-align: middle;"
                      v-else
                    >
                      <p class="text-end-time">{{ nowObj.expectEndDate }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item-box-r">
                <div class="item-box-r-box">
                  <div class="i-box-ground">
                    <div class="jl-table">
                      <div class="jl-table-cell">
                        <p class="text1">{{ remindNumber }}</p>
                        <p class="text2">设置提醒人数</p>
                      </div>
                    </div>
                  </div>
                  <div class="i-box-ground">
                    <div class="jl-table">
                      <div class="jl-table-cell">
                        <p class="text1">{{ visitorsNumber }}</p>
                        <p class="text2">浏览人数</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="jl-auc-view-content" id="jl-auc-section2-point">
      <div class="jl-container">
        <div class="jl-auc-view-tabs">
          <ul class="jl-view-list clearfix">
            <li
              :class="[item.value === tabStatus ? 'item active' : 'item']"
              v-for="(item, index) in tablist"
              :key="index"
              @click="changeTab(item)"
            >
              {{ item.label }}
            </li>
          </ul>
        </div>
        <div class="jl-auc-view-search-wrap" @keyup.enter="search">
          <div class="jl-view-search">
            <input
              type="text"
              class="jl-view-input"
              v-model.trim="keyword"
              placeholder="请输入搜索内容"
            />
            <button class="jl-view-search-btn" @click="search">搜索</button>
          </div>
        </div>
        <div class="jl-auc-view-list-wrap">
          <div v-loading="isloading" class="jl-loading-box">
            <div class="jl-com-nodata-tips" v-if="nodata">
              <div class="jl-com-nodata-box">
                <i class="jl-icon-wushuju"></i>
                <p class="text">暂无数据</p>
              </div>
            </div>
            <ul class="jl-auc-view-list clearfix">
              <li
                class="item"
                v-for="item in list"
                :key="item.id"
                @click="golink(item)"
              >
                <div class="jl-view-listbox">
                  <div class="jl-view-lb-img">
                    <img :src="item.imgsUrl" alt />
                  </div>
                  <div class="jl-view-lb-info">
                    <div class="jl-tips" v-if="item.auctionStatus == 1">
                      已成交
                    </div>
                    <h3>{{ item.name }}</h3>
                    <p class="item-price">
                      起拍价：
                      <span>¥ {{ item.startPrice }}</span>
                    </p>
                    <p class="text1">浏览人数：{{ item.visitorsNumber }}人</p>
                    <p class="text1">
                      时间：{{ item.startDate }} ～
                      {{ item.endDate ? item.endDate : item.expectEndDate }}
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div style="text-align:center;" v-if="list.length > 0">
          <div style="display:inline-block;">
            <v-pagination
              :total="total"
              :display="display"
              :currentPage="current"
              @pagechange="pagechange"
            ></v-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAuctionById, getNowAuctionList } from '../../api/auction';
import Pagination from '../../components/Pagination';
export default {
  name: 'auctionView',
  components: {
    'v-pagination': Pagination
  },
  data() {
    const auctionId = this.$route.query.id;
    return {
      nowObj: {},
      tablist: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '进行中'
        },
        {
          value: 2,
          label: '已结束'
        }
      ],
      tabStatus: 0,
      keyword: '',
      list: [],
      total: 1,
      display: 8,
      current: 1,
      auctionId: auctionId,
      hh: '', //时
      mm: '', //分
      ss: '', //秒
      joinNumber: 0, //参与人数
      visitorsNumber: 0, //浏览人数
      remindNumber: 0, //设置提醒人数
      countdownTime: '',
      isloading: true,
      nodata: false,
      listScrollTop: '',
      ctime: null,
      ctimeRe: null
    };
  },
  created() {
    this.getlist();
    this.refr();
  },
  destroyed() {
    clearTimeout(this.ctime);
    clearTimeout(this.ctimeRe);
  },
  mounted() {
    this.$nextTick(() => {
      this.listScrollTop = this.$publicMethods.getPoint(
        document.getElementById('jl-auc-section2-point')
      ).t;
    });
  },
  methods: {
    search() {
      //搜索
      this.current = 1;
      getNowAuctionList(this);
    },
    changeTab(item) {
      this.tabStatus = item.value;
      this.current = 1;
      this.keyword = '';
      getNowAuctionList(this);
    },
    format(value) {
      //为了兼容ie9时间格式
      if (value) {
        var tt = value.replace(/-/g, '/');
        var time = new Date(tt);
        return time;
      } else {
        return '';
      }
    },
    setTime() {
      let type = this.nowObj.transactionType,
        time = '';
      if (type === 1) {
        time = this.nowObj.endDate
          ? this.nowObj.endDate
          : this.nowObj.expectEndDate;
      } else if (type === 0) {
        time = this.nowObj.startDate;
      }
      let numTime = (this.format(time) - new Date()) / 1000;
      this.setIntervalTime(numTime);
    },
    setIntervalTime(numTime) {
      let h = parseInt(numTime / 3600),
        m = parseInt((numTime - h * 3600) / 60),
        s = parseInt(numTime - h * 3600 - m * 60);
      this.hh = h < 10 ? '0' + h : h;
      this.mm = m < 10 ? '0' + m : m;
      this.ss = s < 10 ? '0' + s : s;
      numTime -= 1;
      if (numTime < 0) {
        clearTimeout(this.ctime);
        clearTimeout(this.ctimeRe);
        this.getlist();
      } else {
        this.ctime = setTimeout(() => {
          this.setIntervalTime(numTime);
        }, 1000);
      }
    },
    setPersonNum(arr = []) {
      let joinNumber = 0,
        visitorsNumber = 0,
        remindNumber = 0;
      arr.forEach(element => {
        joinNumber += parseFloat(element.joinNumber);
        visitorsNumber += parseFloat(element.visitorsNumber);
        remindNumber += parseFloat(element.remindNumber);
      });
      this.joinNumber = joinNumber;
      this.visitorsNumber = visitorsNumber;
      this.remindNumber = remindNumber;
    },
    pagechange(idx) {
      //console.log(idx);
      this.current = idx;
      getNowAuctionList(this);
      window.scrollTo(0, this.listScrollTop);
    },
    getlist() {
      clearTimeout(this.ctime);
      clearTimeout(this.ctimeRe);
      getAuctionById(this);
      getNowAuctionList(this);
    },
    golink(item) {
      this.$router.push({
        path: '/auction/detail',
        query: {
          id: item.id
        }
      });
    },
    //十秒刷新
    refr() {
      clearTimeout(this.ctimeRe);
      this.ctimeRe = setTimeout(() => {
        getAuctionById(this);
        this.refr();
      }, 10000);
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-auc-view-wrap {
  padding-top: 30px;
  padding-bottom: 125px;
  background-color: #f8f8fb;
}
.jl-container {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.jl-auc-view-banner {
  background: url('../../assets/img/zkj-auc-banner.jpg') no-repeat center center;
  background-size: cover;
}
.jl-table {
  display: table;
  width: 100%;
  height: 100%;
  text-align: center;
}
.jl-table-cell {
  display: table-cell;
  vertical-align: middle;
}
.jl-auc-banbox {
  .jl-auc-bantop {
    padding: 46px 0 43px 48px;
    h2 {
      position: relative;
      display: inline-block;
      font-size: 52px;
      color: #fff;
      line-height: 1;
      margin-bottom: 30px;
    }
    .jl-auc-ban-tips {
      position: absolute;
      left: 110%;
      top: 50%;
      width: 84px;
      height: 28px;
      padding: 0 13px;
      background: #e50011;
      margin-top: -14px;
      .tips-text {
        position: relative;
        font-size: 14px;
        color: #fff;
        line-height: 28px;
        font-weight: 100;
        padding-left: 13px;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          margin-top: -4px;
          background: #fff;
        }
      }
    }
    p {
      font-size: 18px;
      color: #fff;
    }
  }
}
.jl-auc-bancontent {
  text-align: center;
  padding-bottom: 30px;
  .item-box {
    display: inline-block;
    text-align: left;
    > div {
      display: inline-block;
      vertical-align: middle;
      height: 158px;
      background-color: rgba($color: #000000, $alpha: 0.4);
    }
    .item-box-l {
      width: 520px;
      margin-right: 24px;
      color: #fff;
      span {
        display: inline-block;
        vertical-align: middle;
      }
      .span-1 {
        font-size: 18px;
        margin-right: 30px;
      }
      .span-2 {
        font-size: 28px;
        width: 52px;
        height: 52px;
        line-height: 52px;
        background-color: #e50011;
      }
      .span-3 {
        font-size: 24px;
        padding: 0 10px;
      }
    }
    .item-box-r {
      width: 104px;
      padding: 0 10px;
      .item-box-r-box {
        position: relative;
        height: 100%;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          width: 100%;
          height: 1px;
          border-top: 1px dashed #fff;
        }
        .i-box-ground {
          width: 100%;
          height: 50%;
          color: #fff;
          .text1 {
            font-size: 24px;
          }
          .text2 {
            font-size: 14px;
          }
        }
      }
    }
  }
}

.jl-auc-view-tabs {
  background: #fff;
  .jl-view-list {
    .item {
      position: relative;
      float: left;
      width: 242px;
      height: 62px;
      line-height: 62px;
      font-size: 14px;
      columns: #333;
      text-align: center;
      border-right: 1px solid #e0e0e0;
      cursor: pointer;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
      }
      &.active {
        color: #e50011;
      }
      &.active:before {
        background-color: #e50011;
      }
    }
  }
}
.jl-auc-view-search-wrap {
  padding: 43px 0;
  text-align: center;
  .jl-view-search {
    display: inline-block;
  }
  .jl-view-input {
    display: inline-block;
    vertical-align: middle;
    width: 580px;
    height: 56px;
    outline: none;
    font-size: 18px;
    padding: 0 50px;
    border-radius: 5px;
    background: url('../../assets/img/zkj-search.png') no-repeat 18px center;
    background-color: #f0f0f0;
    border: 1px solid #e0e0e0;
    margin-right: 20px;
  }
  .jl-view-search-btn {
    width: 107px;
    height: 56px;
    line-height: 56px;
    font-size: 18px;
    color: #e50011;
    text-align: center;
    border: 1px solid #e50011;
    border-radius: 5px;
    background: transparent;
    vertical-align: middle;
  }
}
.jl-auc-view-list {
  margin-left: -15px;
  margin-right: -15px;
  .item {
    float: left;
    width: 25%;
    padding: 0 15px 30px 15px;
    cursor: pointer;
  }
  .jl-view-lb-img {
    // height: 370px;
    overflow: hidden;
    text-align: center;
    background: #fff;
    // line-height: 370px;
    img {
      /* display: inline-block;
      vertical-align: middle;
      max-width: 100%;
      max-height: 100%; */
      display: block;
      width: 100%;
      transition: all 0.3s;
    }
  }
  .jl-view-lb-info {
    position: relative;
    background: #fff;
    padding: 20px 20px 5px 20px;
    .jl-tips {
      position: absolute;
      right: 0;
      top: 20px;
      display: block;
      width: 56px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      font-size: 12px;
      color: #999;
      background: #ccc;
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;
    }
    h3 {
      font-size: 16px;
      color: #333;
      margin-bottom: 20px;
    }
    .item-price {
      font-size: 14px;
      columns: #666;
      padding-bottom: 15px;
      border-bottom: 1px solid #e0e0e0;
      margin-bottom: 15px;
      span {
        font-size: 18px;
        color: #e50011;
      }
    }
    .text1 {
      font-size: 14px;
      columns: #666;
      margin-bottom: 15px;
    }
  }
}

.text-end-time {
  font-size: 24px;
  font-weight: bold;
}

.jl-view-listbox {
  box-shadow: 5px 5px 20px rgba($color: #ccc, $alpha: 0.4);
  transition: all 0.3s;
}

@media screen and (min-width: 1200px) {
  .jl-auc-view-list .item:hover .jl-view-lb-img img {
    transform: scale(1.1);
  }
  .jl-auc-view-list .item:hover .jl-view-listbox {
    box-shadow: 5px 5px 20px rgba($color: #ccc, $alpha: 0.9);
  }
}
</style>
